import React, { useState } from 'react';
    import { motion } from 'framer-motion';
    import SafeIcon from '../common/SafeIcon';
    import { FiSend, FiMail, FiGlobe, FiUser, FiMessageSquare, FiCheckCircle } from 'react-icons/fi';

    const Contact = () => {
      const [status, setStatus] = useState('idle');
      const [formData, setFormData] = useState({
        name: '',
        email: '',
        language: 'English',
        message: ''
      });

      const handleSubmit = (e) => {
        e.preventDefault();
        setStatus('sending');
        setTimeout(() => setStatus('success'), 1500);
      };

      if (status === 'success') {
        return (
          <div className="min-h-screen flex items-center justify-center px-6 bg-[#050505]">
            <motion.div 
              initial={{ opacity: 0, scale: 0.9 }} 
              animate={{ opacity: 1, scale: 1 }}
              className="text-center"
            >
              <div className="w-20 h-20 bg-[#CCFF00] flex items-center justify-center mx-auto mb-8">
                <SafeIcon icon={FiCheckCircle} className="text-black text-4xl" />
              </div>
              <h2 className="text-4xl font-black text-white uppercase tracking-tighter mb-4">Protocol Received</h2>
              <p className="text-slate-500 font-medium max-w-xs mx-auto mb-10">
                Our editorial desk will review your inquiry and respond within 2 hours.
              </p>
              <button 
                onClick={() => setStatus('idle')}
                className="text-[#CCFF00] font-black text-[10px] uppercase tracking-[0.4em] border-b-2 border-[#CCFF00] pb-1"
              >
                Send Another Dispatch
              </button>
            </motion.div>
          </div>
        );
      }

      return (
        <div className="bg-[#050505] min-h-screen pt-44 pb-32 px-6 grid-pattern">
          <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-24">
            
            <motion.div 
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
            >
              <h2 className="text-[#CCFF00] font-mono-data text-xs font-black uppercase tracking-[0.4em] mb-6">Editorial Desk</h2>
              <h1 className="text-6xl md:text-8xl font-black text-white leading-[0.85] tracking-tighter mb-12 uppercase">
                Contact <br />
                <span className="text-transparent" style={{ WebkitTextStroke: '1px #CCFF00' }}>Bureau</span>
              </h1>
              
              <div className="space-y-12 max-w-md">
                <div className="group">
                  <span className="block text-[10px] font-black text-slate-500 uppercase tracking-[0.3em] mb-4">Direct Channel</span>
                  <p className="text-2xl font-bold text-white group-hover:text-[#CCFF00] transition-colors cursor-pointer">editorial@thepitchfeed.com</p>
                </div>
                
                <div className="group">
                  <span className="block text-[10px] font-black text-slate-500 uppercase tracking-[0.3em] mb-4">Global Desk Active</span>
                  <div className="flex items-center gap-4 text-[#CCFF00]">
                    <div className="w-2 h-2 bg-[#CCFF00] animate-pulse"></div>
                    <span className="text-[10px] font-black uppercase tracking-widest">24/7 Operational Status</span>
                  </div>
                </div>
              </div>
            </motion.div>

            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="glass-card p-8 md:p-12 relative overflow-hidden"
            >
              <div className="absolute top-0 left-0 w-full h-1 bg-[#CCFF00]"></div>
              
              <form onSubmit={handleSubmit} className="space-y-8">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div className="space-y-2">
                    <label className="flex items-center gap-2 text-[10px] font-black text-slate-500 uppercase tracking-widest ml-1">
                      <SafeIcon icon={FiUser} className="text-[#CCFF00]" /> Name
                    </label>
                    <input 
                      type="text" 
                      required
                      value={formData.name}
                      onChange={(e) => setFormData({...formData, name: e.target.value})}
                      placeholder="Full Name"
                      className="w-full bg-white/5 border border-white/10 p-5 text-white font-bold outline-none focus:border-[#CCFF00] transition-all"
                    />
                  </div>
                  <div className="space-y-2">
                    <label className="flex items-center gap-2 text-[10px] font-black text-slate-500 uppercase tracking-widest ml-1">
                      <SafeIcon icon={FiMail} className="text-[#CCFF00]" /> E-mail
                    </label>
                    <input 
                      type="email" 
                      required
                      value={formData.email}
                      onChange={(e) => setFormData({...formData, email: e.target.value})}
                      placeholder="work@company.com"
                      className="w-full bg-white/5 border border-white/10 p-5 text-white font-bold outline-none focus:border-[#CCFF00] transition-all"
                    />
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-[10px] font-black text-slate-500 uppercase tracking-widest ml-1">
                    <SafeIcon icon={FiGlobe} className="text-[#CCFF00]" /> Language
                  </label>
                  <select 
                    value={formData.language}
                    onChange={(e) => setFormData({...formData, language: e.target.value})}
                    className="w-full bg-white/5 border border-white/10 p-5 text-white font-bold outline-none focus:border-[#CCFF00] appearance-none cursor-pointer uppercase text-xs tracking-widest"
                  >
                    <option value="English">English</option>
                    <option value="Spanish">Spanish</option>
                    <option value="German">German</option>
                    <option value="French">French</option>
                    <option value="Italian">Italian</option>
                  </select>
                </div>

                <div className="space-y-2">
                  <label className="flex items-center gap-2 text-[10px] font-black text-slate-500 uppercase tracking-widest ml-1">
                    <SafeIcon icon={FiMessageSquare} className="text-[#CCFF00]" /> Message
                  </label>
                  <textarea 
                    rows="4"
                    required
                    value={formData.message}
                    onChange={(e) => setFormData({...formData, message: e.target.value})}
                    placeholder="Briefly describe your inquiry..."
                    className="w-full bg-white/5 border border-white/10 p-5 text-slate-300 font-medium outline-none focus:border-[#CCFF00] transition-all resize-none"
                  />
                </div>

                <button 
                  type="submit"
                  disabled={status === 'sending'}
                  className="w-full py-6 bg-[#CCFF00] text-black font-black text-[11px] uppercase tracking-[0.4em] hover:bg-white transition-all flex items-center justify-center gap-4 group shadow-[0_20px_40px_rgba(204,255,0,0.1)]"
                >
                  {status === 'sending' ? (
                    <div className="w-5 h-5 border-2 border-black border-t-transparent animate-spin"></div>
                  ) : (
                    <>
                      Send Message
                      <SafeIcon icon={FiSend} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                    </>
                  )}
                </button>
              </form>
            </motion.div>
          </div>
        </div>
      );
    };

    export default Contact;